import m from "../../geodata/es2015/burkinaFasoHigh";
window.am4geodata_burkinaFasoHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/burkinaFasoHigh.js
// module id = null
// module chunks = 